import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "sticky-header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "main-title" }, [
  /*#__PURE__*/_createTextVNode(" Fretboard Tool "),
  /*#__PURE__*/_createElementVNode("span", { class: "version" }, "V2")
], -1)
const _hoisted_5 = { class: "rightside-content" }
const _hoisted_6 = { class: "main-container" }
const _hoisted_7 = { class: "fretboard-container" }
const _hoisted_8 = { class: "bottom-settings" }

import FretboardDisplay from "@/components/FretboardDisplay.vue";
import FretboardSettings from "@/components/FretboardSettings.vue";
import InstrumentSelector from "@/components/InstrumentSelector.vue";
import { onMounted } from "vue";
import { useFretboardStore } from "@/stores/fretboard";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useFretboardStore();

onMounted(() => {
  // Ensure the store has an initial scale set
  if (!store.selectedScaleName) {
    store.setSelectedScale("major");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(InstrumentSelector)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(FretboardDisplay)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(FretboardSettings)
      ])
    ])
  ]))
}
}

})